import axios from "axios";
import { Animate, AuthContext, Card, Form, Loader, Row } from "components/lib";
import { useContext, useEffect, useState } from "react";
import logo from "./images/black_logo.png";
import truck_image from "./images/truck.png";
import styles from "./styles.module.scss";

export function Signup(props) {
  const [loading, setLoading] = useState(false);
  const context = useContext(AuthContext);
  const url = window.location.href;

  const [inviteData, setInviteData] = useState(null);

  async function runAPI() {
    if (url.includes("?invite_id=")) {
      setLoading(true);

      const invite_id = url.substring(url.indexOf("?invite_id=") + 11);
      const invite = await axios.get("/api/invite/" + invite_id);
      const data = invite ? invite.data.data : null;

      console.log(invite);

      if (data) {
        setInviteData(data[0]);
      }

      setLoading(false);
    }
  }

  useEffect(() => {
    runAPI();
  }, []);

  return (
    <Animate type="pop">
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className={styles.container}>
            <div className={styles.left}>
              <div className={styles.header}>
                <img
                  src={logo}
                  alt="Logo"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    window.location.href = "https://coverbadger.com";
                  }}
                />
              </div>
              <div className={styles.wrapper}>
                <Row
                  title={
                    inviteData
                      ? "Finish your account creation"
                      : "Create your account"
                  }
                >
                  <div className={styles.desc}>
                    Enter the fields below to get started
                  </div>

                  <Card restrictWidth center>
                    <Form
                      inputs={
                        inviteData
                          ? {
                              name: {
                                label: "Full Name",
                                value: inviteData.owner_name
                                  ? inviteData.owner_name
                                  : inviteData.first_name +
                                    " " +
                                    inviteData.last_name,
                                type: inviteData.first_name ? "hidden" : "text",
                                errorMessage: "Please enter your first name",
                                disabled: true,
                              },
                              email: {
                                label: "Email",
                                type: "hidden",
                                value: inviteData.email,
                                required: true,
                              },
                              password: {
                                label: "Password",
                                type: "password",
                                required: true,
                                complexPassword: true,
                              },
                              invite_id: {
                                type: "hidden",
                                value: inviteData.id,
                              },
                            }
                          : {
                              name: {
                                label: "Full Name",
                                type: "text",
                                required: true,
                                errorMessage: "Please enter your first name",
                              },
                              email: {
                                label: "Email",
                                type: "email",
                                required: true,
                              },
                              password: {
                                label: "Password",
                                type: "password",
                                required: true,
                                complexPassword: true,
                              },
                              confirm_password: {
                                type: "hidden",
                                value: null,
                              },
                            }
                      }
                      url={"/api/user"}
                      method="POST"
                      redirect="/app/onboarding"
                      buttonText="Create Account"
                      callback={context.signin}
                    />
                  </Card>
                  <div className={styles.not_member}>
                    Already have an account?{" "}
                    <span
                      onClick={() => {
                        window.location.href = "/";
                      }}
                    >
                      Log in
                    </span>
                  </div>
                </Row>
              </div>
              <div className={styles.footer}>Coverbadger ©2025</div>
            </div>
            <div
              className={styles.right}
              style={{ backgroundImage: "url(" + truck_image + ")" }}
            />
          </div>
        </>
      )}
    </Animate>
  );
}
